import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import recursosServices from 'services/recursos';
import { diccionarioVista } from '../utils/utils';
import { RUTAS } from 'const/Rutas';
import { convertirFechaConAjuste } from 'helpers/formatFecha';
import { AlertaError, AlertaExito } from 'utils/Alertas';
import { isValorValido } from 'helpers/validaCampos';
import { AuthContext } from 'context';
import { PERMISOS } from 'const/Permisos';
const ESTADO_INICIAL = {
  // Seccion 1 - Recurso Adquirido
  empresa: null, // codigoEmpresa registrado en la base de datos (Integer) - Obligatorio si es que tiene el permiso
  sucursal: null, // codigoSucursal registrado en la base de datos (Integer) - Obligatorio
  tipoRecursoAdquirido: null, // codigoTipoRecursoAdquirido registrado en la base de datos (Integer) - Obligatorio
  cantidad: null, // Double - Obligatorio
  unidadMedida: null, //codigoUnidadMedida registrado en la base de datos (Integer) - Obligatorio
  levantamientoDatos: null, //codigoLevantamientoDatos registrado en la base de datos (Integer) - Opcional
  fechaAdquisicion: '', // Date (yyyy-MM-dd)  - Obligatorio
  numeroGuiaDespacho: null, // Integer (max 10) - Opcional
  // Seccion 2 - Generador - Vendedor del recurso
  rut: '', // String (max 12) - Obligatorio
  nombreEmpresaGenerador: null, // String - Obligatorio
  region: null, // codigoRegion registrado en la base de datos (Integer) - Opcional
  comuna: null, // codigoComuna registrado en la base de datos (Integer) - Opcional
  direccion: null, // String - Opcional
  nombreVia: null, // String - Opcional
  longitudDireccion: null, // Double - Opcional
  latitudDireccion: null, // Double - Opcional
  // Seccion 3 - Transporte
  tipoTransporte: null, // codigoTipoTransporte registrado en la base de datos (Integer) - Opcional
  // Seccion 4 - Contenido reciclado y renovable del recurso
  contenidoReciclado: null, // Double - Opcional
  contenidoRenovable: null, // Double - Opcional
  // Seccion 5 - Envase - embalaje
  embalaje: null, // codigoTipoEmbalaje registrado en la base de datos (Integer) - Opcional
  cantidadEmbalaje: null, // Double - Opcional
  // Seccion 6 - Estimación de residuo a generar
  nombreLER: null, // codigoLER registrado en la base de datos (Integer) y nombreLER (String) - Obligatorio
  nombreSubLER: null, // codigoLER registrado en la base de datos (Integer) y nombreLER (String) - Obligatorio
  nombreSubSubLER: null, // codigoLER registrado en la base de datos (Integer) y nombreLER (String) - Obligatorio
  tipoResiduo: null, // codigoTipoResiduo registrado en la base de datos (Integer) - Obligatorio
  subTipoResiduo: null, // codigoSubTipoResiduo registrado en la base de datos (Integer) - Obligatorio
  archivos: [], // Array de archivos - Opcional
  nombreTipoTratamiento: null, // codigoTipoTratamiento registrado en la base de datos (Integer) - Opcional
  cantidadResiduo: null, // Double - Opcional
  procesoProductivo: null, // String - Opcional
  codigoEmbalaje: null // String - Opcional
};

export const useSubmitRecusosAdquiridos = (codigoRecursoAdquirido, values) => {
  const { isTienePermisos } = useContext(AuthContext);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [recursoAdquirido, setRecursoAdquirido] = useState(ESTADO_INICIAL);
  const [cargaData, setcargaData] = useState(false);

  /**
   * @name cargarRecursoAdquirido
   * Función para cargar el recurso adquirido que se está desplegando, en el caso de que el código no viene se asume que es un nuevo recurso adquirido.
   * @throws Error
   * @return estructura servicio de recurso adquirido
   */

  const cargarRecursoAdquirido = async () => {
    if (codigoRecursoAdquirido !== 'nuevo') {
      setIsLoading(true);
      try {
        const responseRecursoAdquirido =
          await recursosServices.obtieneRecursoAdquirido(
            codigoRecursoAdquirido
          );
        if (responseRecursoAdquirido.status === 200) {
          const recursoAdquirido = responseRecursoAdquirido.data;

          // Nueva forma de formatear la fecha
          const fechaFormateada = convertirFechaConAjuste(
            recursoAdquirido.fechaAdquisicion
          );
          setRecursoAdquirido({
            // Mandatory
            codigoRecursoAdquirido: recursoAdquirido.codigoRecursoAdquirido,
            empresa: recursoAdquirido.sucursal.empresa || null,
            sucursal: recursoAdquirido.sucursal,
            tipoRecursoAdquirido: recursoAdquirido.tipoRecursoAdquirido,
            cantidad: recursoAdquirido.cantidad,
            unidadMedida: recursoAdquirido.unidadMedida,
            levantamientoDatos: recursoAdquirido.levantamientoDatos,
            fechaAdquisicion: fechaFormateada,
            rut: recursoAdquirido.empresaGeneradora.rut,
            nombreEmpresaGenerador:
              recursoAdquirido.empresaGeneradora.nombreEmpresa,
            nombreSubSubLER: recursoAdquirido.generacionResiduo.nombreLER,
            subTipoResiduo: recursoAdquirido.generacionResiduo.tipoResiduo,

            // Optional
            archivos:
              recursoAdquirido.archivos.length > 0
                ? recursoAdquirido.archivos
                : [],
            tipoTratamiento:
              recursoAdquirido.generacionResiduo?.tipoTratamiento,
            numeroGuiaDespacho: recursoAdquirido?.numeroGuiaDespacho,
            region:
              recursoAdquirido?.empresaGeneradora?.direccion?.comuna?.region,
            comuna: recursoAdquirido?.empresaGeneradora?.direccion?.comuna,
            direccion:
              recursoAdquirido?.empresaGeneradora?.direccion?.nombreVia,
            nombreVia: recursoAdquirido.empresaGeneradora?.direccion?.nombreVia,
            longitudDireccion:
              recursoAdquirido.empresaGeneradora?.direccion?.longitudDireccion,
            latitudDireccion:
              recursoAdquirido.empresaGeneradora?.direccion?.latitudDireccion,
            tipoTransporte: recursoAdquirido?.tipoTransporte,
            contenidoReciclado: recursoAdquirido?.contenidoReciclado,
            contenidoRenovable: recursoAdquirido?.contenidoRenovable,
            embalaje: recursoAdquirido?.embalaje?.tipoEmbalaje,
            cantidadEmbalaje: recursoAdquirido?.embalaje?.cantidad,
            cantidadResiduo: recursoAdquirido?.generacionResiduo?.cantidad,
            procesoProductivo:
              recursoAdquirido?.generacionResiduo?.procesoProductivo,
            codigoEmbalaje: recursoAdquirido?.embalaje?.codigoEmbalaje
          });
        }
      } catch (error) {
        console.error('Error en cargaRecursoAdquirido', error);
      } finally {
        setIsLoading(false);
        setcargaData(true);
      }
    } else {
      setIsLoading(false);
      setcargaData(true);
    }
  };

  /**
   * @name handleSubmit
   * Función para enviar los datos del formulario al servicio
   * @param valores estructura formik para nuevo recurso adquirido
   * @return estructura servicio nuevo recurso adquirido
   * @throws Error
   */

  const handleSubmit = async (valores, tipoFormulario) => {
    try {
      if (tipoFormulario === 'ingresar' || tipoFormulario === 'duplicar') {
        await submitNuevoRecuroAdquirido(valores, tipoFormulario);
      } else if (tipoFormulario === 'editar') {
        await submitActualizarRecursoAdquirido(valores);
      }
    } catch (error) {
      console.log('Error en handleSubmit ', error);
      AlertaError(
        `No se ha podido realizar la operación de ${diccionarioVista.nombrePrincipalSingular}`
      );
      throw new Error('Error en handleSubmit ', error);
    }
  };

  /**
   * @name submitNuevoRecuroAdquirido
   * Función para enviar los datos del formulario al servicio
   * @param valores estructura formik para nuevo / duplicado recurso adquirido
   * @return estructura servicio nuevo  recurso adquirido
   * @throws Error
   *
   * */
  const submitNuevoRecuroAdquirido = async (valores, tipoFormulario) => {
    const generar = tipoFormulario === 'ingresar' ? 'crear' : 'duplicar';
    const generarado = tipoFormulario === 'ingresar' ? 'creado' : 'duplicado';
    try {
      const recursoAdquiridoData =
        estructuraServicioNuevoRecursoAdquirido(valores);
      const response = await recursosServices.crearRecursoAdquirido(
        recursoAdquiridoData
      );
      if (response.status === 200) {
        AlertaExito(
          `Se ha ${generarado} el ${diccionarioVista.nombrePrincipalSingular} correctamente`
        );
      }
    } catch (error) {
      console.log(
        'Error en la creación o duplicado de un recurso adquirido  ',
        error
      );
      AlertaError(
        `No se ha podido ${generar} el ${diccionarioVista.nombrePrincipalSingular}`
      );
      throw new Error('Error en submitNuevoRecuroAdquirido ', error);
    }
  };

  /**
   * @name submitActualizarRecursoAdquirido
   * Función para enviar los datos del formulario al servicio
   * @param valores estructura formik para la edición de recurso adquirido
   * @return estructura servicio recurso adquirido
   * @throws Error
   *
   * */
  const submitActualizarRecursoAdquirido = async valores => {
    try {
      const recursoAdquiridoData =
        estructuraServicioNuevoRecursoAdquirido(valores);
      const codigoRecursoAdquiridoInt = parseInt(codigoRecursoAdquirido);
      const response = await recursosServices.actualizaRecursoAdquirido(
        codigoRecursoAdquiridoInt,
        recursoAdquiridoData
      );
      if (response.status === 200) {
        AlertaExito(
          'Se han editado los datos del recurso adquirido correctamente'
        );
      }
    } catch (error) {
      console.log('Error en la edición del recurso adquirido ', error);
      throw new Error('Error en submitNuevoRecuroAdquirido ', error);
    }
  };

  /**
   * @name estructuraServicioNuevoRecursoAdquirido
   * Función para estructurar los valores del formulario a la estructura requerida por el servicio
   * @param valores estructura formik
   * @return estructura servicio nuevo/duplicado recurso adquirido
   */
  const estructuraServicioNuevoRecursoAdquirido = valores => {
    try {
      let estructuraServicio = {};

      // Construcción de la estructura principal
      if (isValorValido(valores.cantidad)) {
        estructuraServicio.cantidad = valores.cantidad;
      }

      if (isValorValido(valores.fechaAdquisicion)) {
        estructuraServicio.fechaAdquisicion = format(
          new Date(valores.fechaAdquisicion),
          'yyyy-MM-dd'
        );
      }

      if (isValorValido(valores.numeroGuiaDespacho)) {
        estructuraServicio.numeroGuiaDespacho = valores.numeroGuiaDespacho;
      }

      if (isValorValido(valores.contenidoReciclado)) {
        estructuraServicio.contenidoReciclado = valores.contenidoReciclado;
      }

      if (isValorValido(valores.contenidoRenovable)) {
        estructuraServicio.contenidoRenovable = valores.contenidoRenovable;
      }

      if (isValorValido(valores.unidadMedida?.codigoUnidadMedida)) {
        estructuraServicio.unidadMedida = {
          codigoUnidadMedida: valores.unidadMedida.codigoUnidadMedida
        };
      }

      // Estructura de generacionResiduo
      estructuraServicio.generacionResiduo = {};

      if (isValorValido(valores.nombreSubSubLER?.codigoLER)) {
        estructuraServicio.generacionResiduo.nombreLER = {
          codigoLER: valores.nombreSubSubLER.codigoLER
        };
      }

      if (isValorValido(valores.subTipoResiduo?.codigoTipoResiduo)) {
        estructuraServicio.generacionResiduo.tipoResiduo = {
          codigoTipoResiduo: valores.subTipoResiduo.codigoTipoResiduo
        };
      }

      if (isValorValido(valores.tipoTratamiento?.codigoTipoTratamiento)) {
        estructuraServicio.generacionResiduo.tipoTratamiento = {
          codigoTipoTratamiento: valores.tipoTratamiento.codigoTipoTratamiento
        };
      }

      if (isValorValido(valores.procesoProductivo)) {
        estructuraServicio.generacionResiduo.procesoProductivo =
          valores.procesoProductivo;
      }

      if (isValorValido(valores.cantidadResiduo)) {
        estructuraServicio.generacionResiduo.cantidad = valores.cantidadResiduo;
      }

      // Empresa : Solo si tiene permisos de administración de sucursales se envía el código de la empresa (negocio)
      if (
        isTienePermisos(PERMISOS.administracionSucursales) &&
        isValorValido(valores.empresa)
      ) {
        estructuraServicio.empresa = {
          codigoEmpresa: valores.empresa.codigoEmpresa
        };
      }

      // Sucursal
      if (isValorValido(valores.sucursal?.codigoSucursal)) {
        estructuraServicio.sucursal = {
          codigoSucursal: valores.sucursal.codigoSucursal
        };
      }

      // Tipo de recurso adquirido
      if (
        isValorValido(valores.tipoRecursoAdquirido?.codigoTipoRecursoAdquirido)
      ) {
        estructuraServicio.tipoRecursoAdquirido = {
          codigoTipoRecursoAdquirido:
            valores.tipoRecursoAdquirido.codigoTipoRecursoAdquirido
        };
      }

      // Empresa generadora
      if (isValorValido(valores.rut)) {
        estructuraServicio.empresaGeneradora = {
          rut: valores.rut,
          nombreEmpresa: valores.nombreEmpresaGenerador
        };

        // Dirección de la empresa
        estructuraServicio.empresaGeneradora.direccion = {};

        if (isValorValido(valores.comuna?.codigoComuna)) {
          estructuraServicio.empresaGeneradora.direccion.comuna = {
            codigoComuna: valores.comuna.codigoComuna
          };
        }

        if (isValorValido(valores.nombreVia)) {
          estructuraServicio.empresaGeneradora.direccion.nombreVia =
            valores.nombreVia;
        }

        if (isValorValido(valores.latitudDireccion)) {
          estructuraServicio.empresaGeneradora.direccion.latitudDireccion =
            valores.latitudDireccion;
        }

        if (isValorValido(valores.longitudDireccion)) {
          estructuraServicio.empresaGeneradora.direccion.longitudDireccion =
            valores.longitudDireccion;
        }
      }

      // Embalaje
      if (
        isValorValido(valores.embalaje?.codigoTipoEmbalaje) ||
        isValorValido(valores.cantidadEmbalaje)
      ) {
        estructuraServicio.embalaje = {};

        if (isValorValido(valores.cantidadEmbalaje)) {
          estructuraServicio.embalaje.cantidad = valores.cantidadEmbalaje;
        }

        if (isValorValido(valores.embalaje?.codigoTipoEmbalaje)) {
          estructuraServicio.embalaje.tipoEmbalaje = {
            codigoTipoEmbalaje: valores.embalaje.codigoTipoEmbalaje
          };
        }
      }

      // Tipo de transporte
      if (isValorValido(valores.tipoTransporte?.codigoTipoTransporte)) {
        estructuraServicio.tipoTransporte = {
          codigoTipoTransporte: valores.tipoTransporte.codigoTipoTransporte
        };
      }

      // Levantamiento de datos
      if (isValorValido(valores.levantamientoDatos?.codigoLevantamientoDatos)) {
        estructuraServicio.levantamientoDatos = {
          codigoLevantamientoDatos:
            valores.levantamientoDatos.codigoLevantamientoDatos
        };
      }

      // Archivos
      if (isValorValido(valores.archivos)) {
        estructuraServicio.archivos = valores.archivos;
      } else {
        estructuraServicio.archivos = [];
      }

      return estructuraServicio;
    } catch (error) {
      console.log('Error en obtenerEstructuraServicio ', error);
      throw new Error('Error en obtenerEstructuraServicio ', error);
    }
  };

  /**
   * @name handleEliminarRecursoAdquirido
   * Función para eliminar un recurso adquirido
   *
   * @param codAdquirido codigo del recurso adquirido
   * @param cargaRecursosAdquiridos función para cargar los recursos adquiridos
   * @return estructura servicio recurso adquirido
   * @throws Error
   *
   * */
  const handleEliminarRecursoAdquirido = async (
    codAdquirido,
    cargaRecursosAdquiridos
  ) => {
    const params = codAdquirido;
    try {
      const response = await recursosServices.eliminaRecursoAdquirido(params);
      if (response.status === 200) {
        AlertaExito('Se ha eliminado el recurso adquirido correctamente');
        cargaRecursosAdquiridos();
        history.push(RUTAS.RECURSOS_ADQUIRIDOS);
      }
    } catch (error) {
      console.log('Error en la eliminación del recurso adquirido ', error);
      AlertaError('No se ha podido eliminar el recurso adquirido');
      throw new Error('Error en handleEliminarRecursoAdquirido ', error);
    }
  };

  return {
    recursoAdquirido,
    isLoading,
    setIsLoading,
    cargarRecursoAdquirido,
    cargaData,
    handleSubmit,
    handleEliminarRecursoAdquirido
  };
};
